import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetaalmanier = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M29.26 9.27H6.74A1.74 1.74 0 0 0 5 11.01v12.52c0 .961.779 1.74 1.74 1.74h22.52A1.74 1.74 0 0 0 31 23.53V11.01a1.74 1.74 0 0 0-1.74-1.74"
    />
    <path
      fill="#60D15D"
      d="M31 11.98H5v2.56h26zM16.67 17.6h-10v1h10zM27.91 32.81 27 34.92h-2.86l-.83-1.97-1.15-.67-2.14.85L18 31.11l.8-1.98-.34-1.29-2.11-.91v-2.86l1.97-.83.67-1.15-.85-2.14 2.02-2.02 1.98.8 1.29-.34.91-2.11h2.86l.83 1.97 1.15.67 2.14-.85 2.02 2.02-.8 1.98.34 1.29 2.11.91v2.86l-1.97.83-.67 1.15.85 2.14-2.02 2.02-1.98-.8zm-2.24-4.35a2.87 2.87 0 0 0 2.87-2.87c0-1.58-1.29-2.87-2.87-2.87s-2.87 1.29-2.87 2.87 1.29 2.87 2.87 2.87M12.56 20.71H6.67v1h5.89z"
    />
    <path
      fill="#00215B"
      d="M25.38 29.23c-.11 0-.21 0-.32-.01-1-.08-1.9-.55-2.55-1.32l.77-.64c.47.56 1.13.9 1.87.97 1.51.12 2.84-.99 2.97-2.5.1-1.22-.63-2.38-1.78-2.81l.35-.94c1.57.58 2.56 2.16 2.42 3.83a3.76 3.76 0 0 1-3.73 3.43z"
    />
    <path
      fill="#00215B"
      d="m18.3 29.53-.28-1.05-2.19-.95v-3.52l2.12-.9.47-.8-.88-2.22 2.49-2.49 2.14.86.89-.23.95-2.19h3.52l.9 2.12.8.46 2.22-.87L33.7 20l-.7.71-1.79-1.79-2.06.81-1.51-.88-.77-1.81h-2.2l-.89 2.03-1.68.45-1.83-.74-1.56 1.55.82 2.06-.88 1.51-1.82.77v2.2l2.04.88.4 1.53z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetaalmanier);

export default ForwardRef;
